export default __webpack_public_path__ + "media/color/bnty-c3fd35b3.svg";